import React from 'react';
import _ from 'lodash';
import {connectWithCore} from 'framework/hocs';
import {Grid, Header, Segment} from 'semantic-ui-react';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';

export const SimpleApplicationHeader = (props) => {
  const {grantStatus, fundingOpportunityName, headerExtra} = props;

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column computer={12}>
          <Header as="h1" id="AFGHeader profile">
            {fundingOpportunityName} {headerExtra ? ' ' + headerExtra : ''}
          </Header>
        </Grid.Column>
        <Grid.Column computer={4}>
          <Segment basic textAlign="right" className="no-padding">
            <strong>
              Status: {_.get(ASSOCIATED_ENTITY_STATUSES, grantStatus, 'N/A')}
            </strong>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default connectWithCore(SimpleApplicationHeader);
